// pages/QHelper.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const QHelper = () => (
  <>
    <title>QHelper - Arthur Efremenko</title>
    <meta name="description" content={projects.qhelper.description} />
    <ProjectTemplate
      project={projects.qhelper}
      screenshots={projects.qhelper.screenshots}
    />
  </>
);

export default QHelper;
